export default __webpack_public_path__ + "static/clients-financing-hero-image-dd038a45fccd1ccc9d307dd62862658f.jpg";